import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const Attention = () => {
  const { getAlterColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="9"
      viewBox="0 0 11 9"
      fill="none"
    >
      <path
        d="M4.90748 0.500001C5.29238 -0.166666 6.25463 -0.166667 6.63953 0.5L10.681 7.5C11.0659 8.16667 10.5848 9 9.81495 9H1.73205C0.962252 9 0.481125 8.16667 0.866025 7.5L4.90748 0.500001Z"
        fill={getAlterColor("#FFE144","rgb(201 192 30)")}
      />
    </svg>
  );
};

export default Attention;

